import { render } from "./TaskPropsCmp.vue?vue&type=template&id=2d870464"
import script from "./TaskPropsCmp.vue?vue&type=script&lang=js"
export * from "./TaskPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__